import * as ToastPrimitive from '@radix-ui/react-toast'
import { X } from 'lucide-react'

import { cn } from '@/lib/utils'

export const ToastProvider = ToastPrimitive.Provider

export function ToastViewport({ className, ...props }: ToastPrimitive.ToastViewportProps) {
  return (
    <ToastPrimitive.Viewport
      className={cn(
        'fixed right-0 bottom-0 z-[100] flex w-full max-w-sm flex-col gap-2 p-4 outline-none',
        className,
      )}
      {...props}
    />
  )
}

export interface ToastProps extends ToastPrimitive.ToastProps {
  variant?: 'success' | 'error' | 'warning'
}

const VARIANT_CLASSNAME: Record<NonNullable<ToastProps['variant']>, string> = {
  error: 'border-destructive/50 bg-destructive text-destructive-foreground',
  warning: 'border-warning/50 bg-warning text-warning-foreground',
  success: 'border-border bg-card text-card-foreground',
}

export function Toast({ className, variant = 'success', ...props }: ToastProps) {
  return (
    <ToastPrimitive.Root
      className={cn(
        'grid grid-cols-[1fr_auto] items-start gap-3 rounded-lg border p-4 shadow-lg',
        VARIANT_CLASSNAME[variant],
        className,
      )}
      {...props}
    />
  )
}

export function ToastTitle({ className, ...props }: ToastPrimitive.ToastTitleProps) {
  return <ToastPrimitive.Title className={cn('text-sm font-semibold', className)} {...props} />
}

export function ToastDescription({ className, ...props }: ToastPrimitive.ToastDescriptionProps) {
  return <ToastPrimitive.Description className={cn('text-sm opacity-90', className)} {...props} />
}

export function ToastClose({ className, ...props }: ToastPrimitive.ToastCloseProps) {
  return (
    <ToastPrimitive.Close
      className={cn(
        'focus-visible:ring-ring rounded-sm opacity-70 outline-none hover:opacity-100 focus-visible:ring-2',
        className,
      )}
      {...props}
    >
      <X className="h-4 w-4" />
    </ToastPrimitive.Close>
  )
}
